export default "__VITE_ASSET__omAmnSjE__"